import type { FunctionComponent } from "react";
import { ProposalAdminPartial } from "../../../partials/admin/proposal/proposal.admin.partials";

export const ProposalAdminScreen: FunctionComponent = () => {
  return <ProposalAdminPartial />;
};
